import * as React from "react";
const SvgFiRrMelon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-melon_svg__a)">
      <path
        fill="#062147"
        d="M22.374 2.324A4.336 4.336 0 0 0 15.5 1.273L1.274 15.5A4.35 4.35 0 0 0 .06 19.242c.718 3.917 5.816 4.606 9.038 4.765 10.88.157 18.424-11.958 13.277-21.683M12.42 12.42a5.37 5.37 0 0 1-6.237.995l7.233-7.234a5.38 5.38 0 0 1-.996 6.239m5.8 5.8a12.87 12.87 0 0 1-14.987 2.374 2.323 2.323 0 0 1-.546-3.683l2.037-2.037c6.563 4.133 14.25-3.623 10.16-10.161l2.027-2.027a2.32 2.32 0 0 1 3.681.546 12.87 12.87 0 0 1-2.376 14.984z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-melon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMelon;
